<template>
  <header class="py-8">
    <slot name="header" />
  </header>
  <Table
    :slotData="classes"
    :columns="columns"
    :loading="loading"
    :filters="filters"
    :params="params"
    :customActions="true"
    @onFilter="filterFor()"
    @onClearFilter="clearFilter()"
    @onPaginate="paginate($event)"
  >
    <template #filters>
      <InputText v-if="filterType === 'name'" v-model="filters.name" />
    </template>
    <template #actions="{ columnProps }">
      <Button
        class="btn-simple flex gap-2"
        @click.prevent="showClassCalendar(columnProps)"
      >
        <v-icon name="bi-calendar-event" />
        <span>{{
          $t("labels.generic", { pt: "Ver calendário", en: "See calendar" })
        }}</span>
      </Button>
    </template>
  </Table>

  <EmptyData
      :data="!classes || classes.length == 0"
      :label="emptyState.description"
      :image="emptyState.image"
      imgSize="h-40 md:h-64 mt-20"
      msgSize="md:w-3/12"
    />
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { ChaptersService } from "../chapters.service";
import { QueryParams } from "@/models/query-params.model";
import { columns, actions } from "./classTable.utils";
export default defineComponent({
  name: "classroom-table",
  data() {
    return {
      classes: [],
      columns: columns,
      actions: actions,
      loading: false,
      filters: { name: null, isCleareable:false},
      hasStatus: true,
      params: new QueryParams(),
      filterType: "name",
      emptyState: {
        image: "empty_courses.svg",
        description: this.$t("labels.generic", {
          pt: "Nenhuma turma adicionada para esse curso",
          en: "There's any class added for this course",
        }),
      } as any,
    };
  },
  emits: ["updateClass"],

  methods: {
    filterFor() {
      this.filters.isCleareable = true
      Object.assign(this.params, {...this.filters})
      this.getClasses(this.params)
    },
    clearFilter() {
      this.filters.name =null;
      delete this.params.name;
      this.filters.isCleareable = false
      this.getClasses(this.params) 
    },
   
    

    paginate(event:{page:number, rows:number}) {
      const {page, rows} = event
      this.params.page = page
      this.params.size = rows
      this.getClasses(this.params)
    },
    getClasses(params:QueryParams) {
      this.service.classes.subscribe({
        next: (response) => {
          this.classes = response.content;
          this.params.total = response.total;
          this.loading = false
        },
        complete:()=>{
          this.loading = false
        }
      });
      this.loading = true;
      this.service.getAllClasses(params);
    },
    showClassCalendar(columnProps) {
      this.$emit("updateClass", columnProps?.data);
    },
   
  },
  computed: {
    service(): ChaptersService {
      return new ChaptersService();
    },
  },
  mounted() {
    this.params.courseId = this.$route.params.id as string
    this.getClasses(this.params);
  },
});
</script>
